import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M3.27366 4.32387C3.61426 4.31574 3.90734 4.44575 4.15289 4.68951C4.49348 5.0389 4.84201 5.38016 5.17468 5.7458C5.30934 5.89206 5.38063 5.88393 5.5232 5.7458C6.62421 4.62451 7.73314 3.51134 8.84207 2.39817C9.36485 1.87002 10.149 1.87002 10.6401 2.38191C11.1391 2.90194 11.1154 3.69009 10.5926 4.22637C9.15891 5.66455 7.73314 7.11086 6.29946 8.54904C5.69747 9.15032 4.98458 9.15032 4.39051 8.54904C3.71723 7.86652 3.03604 7.19211 2.36276 6.50146C1.97463 6.10332 1.91126 5.60767 2.10929 5.09578C2.29147 4.61638 2.7588 4.32387 3.27366 4.32387Z"
      fill="#00AB59"
    />
  </Svg>
);
export default SVGComponent;
